import axios from 'axios';

import {
    KYB_API_BASE_URL
} from '../../../../constants/index';

export default class ComplianceScreeningQueriesService {
    static instance;
    resource = `${KYB_API_BASE_URL}/kyb/compliance-screening/query`;

    static getInstance() {
        if (!ComplianceScreeningQueriesService.instance) {
            ComplianceScreeningQueriesService.instance = new ComplianceScreeningQueriesService();
        }

        return ComplianceScreeningQueriesService.instance;
    }

    async fetchQueries(params = {}) {
        const response = await axios.get(
            `${this.resource}/list`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchQueryItems(queryId, params = {}) {
        const response = await axios.get(
            `${this.resource}/${queryId}/items`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchQueryItemsOverview(queryId, params = {}) {
        const response = await axios.get(
            `${this.resource}/${queryId}/header`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async createQuery(payload) {
        const response = await axios.post(
            `${this.resource}/create`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data;
    }

    async finalizeQuery(queryId, payload) {
        const response = await axios.post(
            `${this.resource}/${queryId}/finalize`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data;
    }

    async fetchQueryDetail(queryId, params = {}) {
        const response = await axios.get(
            `${this.resource}/${queryId}/detail`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async deleteQuery(queryId) {
        const response = await axios.delete(
            `${this.resource}/${queryId}/delete`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data;
    }
}
